import dayjs, { Dayjs } from 'dayjs';

// Kunden ser utskicksdatumet en dag tidigare än DB-värdet (produktionsdagen är dagen innan). DB-värdet/date_id och
// alla beräkningar (medlemsår/friperiod) använder fortfarande det riktiga datumet – detta är enbart för visning.
export const toCustomerSendDate = (dbDate: Dayjs | string | Date | null | undefined): Dayjs | null => {
  if (!dbDate) return null;
  const d = dayjs(dbDate);
  return d.isValid() ? d.subtract(1, 'day') : null;
};

// Kund-format med veckodag, t.ex. "mån 2 nov 2026".
export const formatCustomerSendDate = (dbDate: Dayjs | string | Date | null | undefined): string => {
  const d = toCustomerSendDate(dbDate);
  return d ? d.format('ddd D MMM YYYY') : '';
};
